import common from '@/store/common/mutations';
import * as types from './mutation-types';
import moment from 'moment';

let searchDate = moment().startOf('year').format('YYYY');

//화면 진입시 초기화
const getInit = () => {
	return {
		searchParams: {
			carScn: '', //차량구분
			pacScn: '', //승상구분
			flclSpc: '', //연료전지사양
			saleRegn: '', //판매지역

			searchDate: searchDate //기준년도
		},
		pmcSaleListScrId: '', //차량판매정보 scrId
		carScnList: [], //검색 차량구분 셀렉트박스
		pacScnList: [], //검색 승상구분 셀렉트박스
		plntCdList: [], //검색 생산공장 셀렉트박스
		flclSpcList: [], //검색 연료전지사양 셀렉트박스
		saleNatList: [], //검색 판매국가 셀렉트박스
		occuRegnList: [], //검색 판매지역 셀렉트박스

		grdList: [], //그리드리스트
		dayCols: [] //그리드 컬럼(년월컬럼)
	};
};

export default {
	...common,
	[types.STATE_INIT]: state => {
		//초기화
		Object.assign(state, getInit());
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	}
};
